import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from '../../shared-services/services/alert.service';
import { SecurityService } from 'src/app/shared-services/services/security.service';
import { StartStoreInfoModel } from 'src/app/shared-services/models/stores.model';
import { ResponseErrorHandler } from 'src/app/shared-services/services/response-error.handler';

@Component({
    selector: 'app-start',
    templateUrl: './start.component.html'
})
export class StartComponent implements OnInit {

    public errorHandler: ResponseErrorHandler;

    constructor(
        private securityService: SecurityService,
        private router: Router,
        private alertService: AlertService) {

        this.errorHandler = new ResponseErrorHandler(this.router, this.alertService);
    }

    ngOnInit() {

        this.securityService.getStart()
            .subscribe((data: StartStoreInfoModel) => {
                this.securityService.startStoreInfo = data;
                this.securityService.currentCountryCode = data.countryCode;

                this.router.navigate([`/orders`]);
            },
                errorResponse => {
                    this.errorHandler.handle(
                        errorResponse,
                        'Could not reach api server'
                    );
                });
    }
}
